/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('deprecated_groupCtrl', ['$scope', '$http', 'NetworkService','MainService', function ($scope, $http, networkService, MainService) {
        
        
        var email = MainService.getEmail();
        networkService.getGroupsForUser(email, function(data){
            $scope.groups = data
        });
        
}])